import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Form, Radio, Card } from "antd";
import { useI18n, useUpsell } from "../../../../../contexts";
import { useUpsellModalVisualContentBlocker } from "../../../../../hooks";
const FormContentBlockerFieldVisualContentType = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    const { modal, tag } = useUpsellModalVisualContentBlocker();
    const visualContentTypeTitles = useMemo(()=>({
            map: __("Map"),
            "audio-player": __("Audio player"),
            "video-player": __("Video player"),
            "feed-text": __("Feed (text)"),
            "feed-video": __("Feed (image/video)"),
            generic: __("None of these")
        }), [
        __
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.isVisualDarkMode !== nextValues.isVisualDarkMode || prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType,
                children: (param)=>{
                    let { getFieldValue } = param;
                    const isVisual = getFieldValue("isVisual");
                    const visualType = getFieldValue("visualType");
                    return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsx(Form.Item, {
                        label: __("Content type"),
                        required: true,
                        extra: tag,
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: "visualContentType",
                            rules: [
                                {
                                    required: true,
                                    message: __("Please choose an option!")
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(Radio.Group, {
                                size: "large",
                                buttonStyle: "solid",
                                className: "rcb-antd-radio-button-card",
                                children: Object.keys(visualContentTypeTitles).map((type)=>{
                                    const title = visualContentTypeTitles[type];
                                    return /*#__PURE__*/ _jsx(Radio.Button, {
                                        value: type,
                                        disabled: !isPro,
                                        children: /*#__PURE__*/ _jsx(Card, {
                                            style: {
                                                width: 240
                                            },
                                            bordered: false,
                                            size: "small",
                                            cover: /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        style: {
                                                            display: getFieldValue("isVisualDarkMode") ? "none" : undefined
                                                        },
                                                        src: `https://assets.devowl.io/in-app/wp-real-cookie-banner/visual-content-blocker-preview/${type}-light.png`
                                                    }),
                                                    /*#__PURE__*/ _jsx("img", {
                                                        style: {
                                                            display: getFieldValue("isVisualDarkMode") ? undefined : "none"
                                                        },
                                                        src: `https://assets.devowl.io/in-app/wp-real-cookie-banner/visual-content-blocker-preview/${type}-dark.png`
                                                    })
                                                ]
                                            }),
                                            children: /*#__PURE__*/ _jsx(Card.Meta, {
                                                title: title
                                            })
                                        })
                                    }, type);
                                })
                            })
                        })
                    });
                }
            })
        ]
    });
};
export { FormContentBlockerFieldVisualContentType };
